import { render } from "./TableFingers.vue?vue&type=template&id=671d3cae&scoped=true"
import script from "./TableFingers.vue?vue&type=script&lang=js"
export * from "./TableFingers.vue?vue&type=script&lang=js"

import "./TableFingers.vue?vue&type=style&index=0&id=671d3cae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671d3cae"]])

export default __exports__